import axios from 'axios';
import { isEmpty } from '.';

const setLanguageToHeader = (language) => {
   if (language) {
      let languageHeader = "zh-CN";
      if(language == "日本語"){
         languageHeader = "ja-JP";
      }
      else if(language == "한국어"){
         languageHeader = "ko-KR";
      }
      else if(language == "English"){
         languageHeader = "en-US";
      }
      
   } else {
      axios.defaults.headers.common['Language'] = "zh-CN";
   }
}

export default setLanguageToHeader;


// WEBPACK FOOTER //
// ./src/common/cores/setLanguageToHeader.js